export enum Placement {
  ActiveProducts = 'item_page.rr_new_1',
  RecentlyViewed = 'item_page.recently_viewed',
  SameSeller = 'item_page.same_seller',
  SameSeller2 = 'item_page.same_seller2',
  SimilarInStockProducts = 'item_page.OOS',
  SimilarProducts = 'item_page.entrypoint',
  TopProducts = 'add_to_cart_page.new_rr1',
}
